module.exports = __webpack_public_path__ + "assets/chevron-down-navbar.efe80223.svg";